import Menu from "../../components/Menu"
import RoundyContainer from "../../components/RoundyContainer"
import HouseholdMain from "../../components/ChangeRequest_HouseholdChangeComp/1_Household/HouseholdMain"
import { HouseholdChangeContextComp } from "../../components/ChangeRequest_HouseholdChangeComp/HouseholdChangeContext"
import HouseholdProgressBarSect from "../../components/UpdateDriversComp/HouseholdProgressBarSect"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const UpdateHousehold = (props) => {
    const { userData } = props.user
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
        navigate("/404")
        return
    }, [])
    return (
        <>
        <HouseholdChangeContextComp>
            <Menu Title={"HOUSEHOLD CHANGE"} FirstName={userData.firstName} userData={userData} />
            <HouseholdProgressBarSect screen={"Household"} state={userData?.state} />
            <RoundyContainer Content={HouseholdMain} NoRoundy
                params={{
                    storedData: { ...props.storedData },
                    setStoredData: props.setStoredData
                }}
            />
        </HouseholdChangeContextComp>
        </>
    )
}

export default UpdateHousehold